export default __webpack_public_path__ + "static/media/2023_September_Kuh.51320411.webp";